import React, { useState } from 'react';
import produce from 'immer';
import { Link } from 'react-tiger-transition';
import { makeStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PostpaidTopup from '../../dialogs/PostpaidTopup';
import PrepaidTopup from '../../dialogs/PrepaidTopup';
import ChangePassword from '../../dialogs/ChangePassword';
import ChangeUserAddress from '../../dialogs/ChangeUserAddress';
import ChangeService from '../../dialogs/ChangeService';
import ChargePrepaid from '../../dialogs/ChargePrepaid';
import ChangeSubscription from '../../dialogs/ChangeSubscription';
import ChangeSubscriptionDataLevel from '../../dialogs/ChangeSubscriptionDataLevel';
import OrderSimcard from '../../dialogs/OrderSimcard';
import ChangeAddress from '../../dialogs/ChangeAddress';
import ActivateSimcard from '../../dialogs/ActivateSimcard';
import Blocking from '../../dialogs/Blocking';
import ViewPinPuk from '../../dialogs/ViewPinPuk';
import ChangePaymentMethod from '../../dialogs/ChangePaymentMethod';
import ChangePaymentCard from '../../dialogs/ChangePaymentCard';
import Friends from '../../dialogs/Friends';
import isWebview from 'is-ua-webview';
import { isDesktop } from 'react-device-detect';

const { forwardRef, useImperativeHandle } = React;

const CustomDialog = withStyles({
    root: {
        '& .MuiDialog-paperFullScreen': {
            borderTopLeftRadius: '30px',
            borderTopRightRadius: '30px',
            marginTop: '50px',
            maxWidth: '760px',
            height: 'calc(100% - 50px)',
            overflowY: 'hidden',
        },
    },
})(Dialog);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" timeout={1000} ref={ref} {...props} />;
});

const SparkleDialog = forwardRef((props, ref) => {
    const [localState, internalSetLocalState] = useState({ dialogOpen: false, url: '', type: '' });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    };
    const handleClose = () => {
        setLocalState({ dialogOpen: false });
        setLocalState({ type: '' });
        setLocalState({ url: '' });
    };
    const handleChangeDialog = (newType) => {
        handleClose();
        setLocalState({ type: newType });
        setLocalState({ dialogOpen: true });
    }
    const isWebView = isWebview(window.navigator.userAgent);

    useImperativeHandle(ref, () => ({
        openUrl(url, newWindow) {
            setLocalState({ url: url });
            if (isWebView || isDesktop || newWindow) {
                var elem = document.getElementById('navlink');
                if (elem) {
                    elem.href = url;
                    elem.click();
                };
            }
            else {
                setLocalState({ type: 'iFrame' });
                setLocalState({ dialogOpen: true });
            }
        },
        showDialog(type) {
            setLocalState({ type: type });
            setLocalState({ dialogOpen: true });
        }
    }));
    return (
        <div>
            <a id="navlink" href={localState.url} target='_blank' />
            <CustomDialog fullScreen open={localState.dialogOpen} onClose={handleClose} TransitionComponent={Transition}>
                <Toolbar variant="dense">
                    <Grid container direction="row" justify="flex-end" alignItems="center">
                        <IconButton color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Toolbar>
                {localState.type !== 'iFrame' &&
                    <div style={{ overflowY: 'overlay' }}>
                        {localState.type === 'changePassword' &&
                            <ChangePassword handleClose={handleClose} />}
                        {localState.type === 'postpaidTopup' &&
                            <PostpaidTopup handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'prepaidTopup' &&
                            <PrepaidTopup handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'chargePrepaid' &&
                            <ChargePrepaid handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changeUser' &&
                            <ChangeUserAddress handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changeService' &&
                            <ChangeService handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changeSubscription' &&
                            <ChangeSubscription handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changeSubscriptionDataLevel' &&
                            <ChangeSubscriptionDataLevel handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'orderSimcard' &&
                            <OrderSimcard handleClose={handleClose} handleRefresh={props.handleRefresh} handleChangeDialog={handleChangeDialog} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changeAddress' &&
                            <ChangeAddress handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'activateSimcard' &&
                            <ActivateSimcard handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'blocking' &&
                            <Blocking handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changePaymentMethod' &&
                            <ChangePaymentMethod handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'changePaymentCard' &&
                            <ChangePaymentCard handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'viewFriends' &&
                            <Friends handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        {localState.type === 'viewPinPuk' &&
                            <ViewPinPuk handleClose={handleClose} handleRefresh={props.handleRefresh} SubscriptionNo={props.subscriptionNo} />}
                        <div style={{ height: '40px' }} />
                    </div>
                }
                {localState.type === 'iFrame' &&
                    <div style={{ width: '100%', height: '100%' }}>
                        <object type="text/html" data={localState.url} style={{ width: '100%', height: '100%' }}>
                        </object>
                    </div>
                }
            </CustomDialog>
        </div>
    );
});

SparkleDialog.displayName = 'SparkleDialog';

export default SparkleDialog;